export default function initMap() {
  centerNarrowMap();

  document.querySelectorAll('section.map figure a.marker').forEach((pin) => {
    pin.setAttribute('data-marker-target', pin.hash);
    pin.removeAttribute('href');
    locationInfoOverflow(pin);
  });

  document.querySelectorAll('section.map .addresses article .close').forEach((close) => {
    close.addEventListener('click', (e) => {
      e.target.closest('article').classList.remove('clicked');
    });
  });
}

function centerNarrowMap() {
  document.querySelectorAll('section.map figure').forEach((map) => {
    map.scrollTo((map.scrollWidth - map.clientWidth) / 2, 0);
  });
}

function locationInfoOverflow(content) {
  content.addEventListener('pointerdown', (e) => {

    document.querySelectorAll('section.map .addresses article').forEach((location) => {
      location.classList.remove('clicked');
    });

    const target = document.querySelector(e.target.closest('[data-marker-target]').getAttribute('data-marker-target'));
    target.classList.toggle('clicked');
  });
}
